import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'

export interface IScanforAcceptPacketGetOn {
    checked_getorderdestnationorg:Boolean
    checked_voice: Boolean
  

}

@Module({ dynamic: true, store, name: 'store_scanforacceptpacketgeton' })
class ScanforAcceptPacketGetOn extends VuexModule implements IScanforAcceptPacketGetOn {

    public checked_getorderdestnationorg = false;
    public checked_voice = false;

    
    @Mutation
    public GetOrderDestnationOrgChangeState(state) {
        this.checked_getorderdestnationorg = state;
        // this.pageState = flag;
        // this.pageStateChangeTime =Date.now();
    }

    @Mutation
    public VoiceChangeState(state) {
        this.checked_voice = state;
        // this.pageState = flag;
        // this.pageStateChangeTime =Date.now();
    }

}

export const ScanforAcceptPacketGetOnModule = getModule(ScanforAcceptPacketGetOn)
